// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1FwF9","balanceDisclaimer":"posDashboard_balanceDisclaimer__jPDpc"};